export const liteThemeColors = {
  //info colors

  infoMain: "#F4F7F9",

  //error color

  error: "#FF3C3C",
  errorLite: "#FFD8D8",

  //success

  success: "#2C811D",
  successLite: "#C8FFAD",

  //primary colors

  primary: "#377DFF",
  primaryLite: "#0C2C62",
  primaryDark: "#8D8C8C",

  //secondary colors

  secondary: "#43D3A8",
  secondaryLite: "#059ba8",
  secondaryDark: "#F2EEEE",
  secondaryMain:"#c2eafc",

  //text colors

  textMain: "#000",
  textLight: "#575757",
  textDark: "#fff",
  grayText: "#575757",
  liteGrayText: "#BABABA",

  //links colors

  linkPrimary: "#fff",
  linkSecondary: "#fff",

  //grey colors

  A100: "#C4C4C4",

  //common colors

  white: "#fff",
  black: "#000",
  divider: "rgba(0, 0, 0, 0.12)",
  cardShadow: "rgba(23, 70, 161, .11)",
  bgGradient:
    "linear-gradient(90deg, rgba(3, 14, 32, 1) 3%, rgba(40, 92, 188, 1) 150%)",
};
